<div class="main-area row">
  <div class="environment-list-column column">
    <div class="environment-list-header toolbar">
      <div class="header">
        <span class="logo">Launchpad</span>
        <span class="logo-subtitle">Create your own environment and run notebooks with full control</span>
      </div>
      <span class="toolbar-spacer"></span>
      <div class="action-buttons-main">
        <button *ngIf="((this.environments | async)?.length === 0)" id="create-environment-action" mat-icon-button matTooltip="Create a new environment"
          (click)="showCreateEnvironmentDialog()">
          <mat-icon>add</mat-icon>
        </button>
        <button *ngIf="!((this.environments | async)?.length === 0)" id="create-environment-action" mat-icon-button
          matTooltip="{{((this.user|async)?.envCount || 0) >= ((this.profileType|async)?.maxMachines || 0)?'Maximum environments reached':'Create a new environment'}}"
          disabled="{{((this.user|async)?.envCount || 0) >= ((this.profileType|async)?.maxMachines || 0)}}"
          (click)="showCreateEnvironmentDialog()">
          <mat-icon>add</mat-icon>
        </button>
      </div>
      <div class="action-buttons-main kebab">
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="showCreateEnvironmentDialog()">
            <img class="action-button" src="./assets/icon-add-new.svg" />
            <span>Create environment</span>
          </button>
        </mat-menu>
      </div>
    </div>
    <div class="ai-studio-container" *ngIf="authService.canAccessAiStudio$ | async">
      <button mat-flat-button id="open-ai-studio-action" class="ai-studio-button" (click)="openAiStudio()">
        Open AI Studio
      </button>
    </div>
    <div class="action-in-progress">
      <div *ngIf="isLoadingResults">
        <mat-progress-bar mode="indeterminate" class="progress-bar" color="accent"></mat-progress-bar>
      </div>
    </div>
    <div class="enviornment-list-container">
      <!-- Carousel - Always visible -->
      <div class="carousel-container" [hidden]="isLoadingResults">
         <mat-accordion class="environment-accordion" *ngIf="((this.environments | async)?.length || 0) > 0">
          <mat-expansion-panel *ngFor="let environment of (this.environments | async)"
            [class.selected]="this.selectedEnvironment!.name == environment.name"
            (opened)="this.selectedEnvironment = environment"
            hideToggle>
            <mat-expansion-panel-header hide>
              <div class="environment-header-content">
                <div class="environment-header-left">
                  <div class="environment-name-row">
                    <div class="environment-name">{{environment.name}}</div>
                    <ng-container *ngIf="getEnvironmentNotifications(environment.name)[0] as notif">
                      <mat-icon
                        [ngClass]="['env-notification-icon', 'env-notification-icon-' + notif.type.toLowerCase()]"
                        [matTooltip]="notif.title + ': ' + notif.text"
                        matTooltipPosition="right"
                        (click)="$event.stopPropagation()">
                        {{getNotificationIcon(notif.type)}}
                      </mat-icon>
                    </ng-container>
                  </div>
                  <div class="environment-state-badge">
                    <img *ngIf="environment.state === 'STOPPED'" class="state-icon" src="./assets/state-stopped.svg" />
                    <img *ngIf="environment.state === 'RUNNING'" class="state-icon" src="./assets/state-running.svg" />
                    <img *ngIf="['TERMINATED', 'FAILED'].includes(environment.state)" class="state-icon" src="./assets/state-terminated.svg" />
                    <mat-progress-spinner
                      *ngIf="['PROVISIONING', 'INITIALIZING', 'STARTING', 'STOPPING', 'REPAIRING', 'TERMINATING'].includes(environment.state)"
                      class="state-spinner" color="accent" mode="indeterminate" diameter="14">
                    </mat-progress-spinner>
                    <div class="state-text-container">
                      <span [ngClass]="['state-text', environment.state.toLowerCase()]">{{environment.state}}</span>
                      <span *ngIf="getProvisioningCountdown(environment)" class="provisioning-countdown">
                        {{ getProvisioningCountdown(environment) }}
                      </span>
                    </div>
                  </div>
                  <div class="environment-days">{{environment.createDate | daysRemaining }} days remaining</div>
                </div>
                <div class="environment-header-right">
                  <div class="environment-actions">
                    <img class="action-icon" matTooltip="Start environment"
                      [class.disabled]="environment.state !== 'STOPPED'"
                      (click)="$event.stopPropagation(); environment.state === 'STOPPED' && startEnvironment(environment.name)"
                      src="./assets/icon-start.svg" />
                    <img class="action-icon" matTooltip="Stop environment"
                      [class.disabled]="environment.state !== 'RUNNING'"
                      (click)="$event.stopPropagation(); environment.state === 'RUNNING' && stopEnvironment(environment.name)"
                      src="./assets/icon-stop.svg" />
                    <img class="action-icon" matTooltip="Delete environment"
                      [class.disabled]="environment.state !== 'RUNNING' && environment.state !== 'STOPPED' && environment.state !== 'TERMINATED' && environment.state !== 'FAILED'"
                      (click)="$event.stopPropagation(); (environment.state === 'RUNNING' || environment.state === 'STOPPED' || environment.state === 'TERMINATED' || environment.state === 'FAILED') && confirmDeleteEnvironment(environment.name)"
                      src="./assets/icon-delete.svg" />
                    <mat-icon class="action-icon info-icon">info</mat-icon>
                  </div>
                  <button [disabled]="environment.state !== 'RUNNING' || !getJupyterlabUrl(environment)" mat-flat-button color="primary"
                    (click)="$event.stopPropagation(); goToDemos(environment)" class="run-demos-button">
                    <span>Run Demos</span>
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                  <button *ngIf="environment.mcpDnsName" [disabled]="environment.state !== 'RUNNING' || !getMcpConfigUrl(environment)" mat-flat-button color="primary"
                    (click)="$event.stopPropagation(); goToMcpConfig(environment)" class="mcp-config-button">
                    <span *ngIf="getTeraUiCountdown(environment) && environment.state === 'RUNNING'" class="btn-spinner"></span>
                    <span>Try Tera</span>
                    <span *ngIf="getTeraUiCountdown(environment) && environment.state === 'RUNNING'" class="timer-badge">({{ getTeraUiCountdown(environment) }})</span>
                    <mat-icon *ngIf="!(getTeraUiCountdown(environment) && environment.state === 'RUNNING')">open_in_new</mat-icon>
                  </button>
                </div>
              </div>
            </mat-expansion-panel-header>
            
            <div class="expansion-content">
              <div class="connection-info-row">
                <span class="info-label">Host:</span>
                <span class="info-value">{{ environment.dnsName }}</span>
                <fa-icon [icon]="faCopy" class="copy-icon" (click)="copyText(environment.dnsName, 'dns')"></fa-icon>
              </div>
              <div class="connection-info-row" *ngIf="environment.mcpDnsName">
                <span class="info-label">MCP:</span>
                <span class="info-value">{{ environment.mcpDnsName }}/mcp</span>
                <fa-icon [icon]="faCopy" class="copy-icon" (click)="copyText(environment.mcpDnsName + '/mcp', 'mcp')"></fa-icon>
              </div>
              <div class="connection-info-row">
                <span class="info-label">Username:</span>
                <span class="info-value">demo_user</span>
                <fa-icon [icon]="faCopy" class="copy-icon" (click)="copyText('demo_user', 'user')"></fa-icon>
              </div>
              <div class="connection-info-row">
                <span class="info-label">Password:</span>
                <span class="info-value password-hint">Password used at creation</span>
              </div>
              
              <div class="connection-details-cta">
                Need help connecting? 
                <a class="cta-link" href="https://quickstarts.teradata.com/" target="_blank">
                  View Getting Started Guide
                  <fa-icon [icon]="faExternalLink"></fa-icon>
                </a>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <div class="enviornment-list-spacer" *ngIf="((this.environments | async)?.length || 0) > 0"></div>
        <div class="no-env-message-below-carousel" *ngIf="((this.environments | async)?.length === 0)">
          <div class="main-message">No environment</div>
          <div class="hint">Create an environment to try out Trial.</div>
          <button class="secondary-create-button" mat-flat-button color="primary" (click)="showCreateEnvironmentDialog()">
            <span>Create</span>
            <mat-icon iconPositionEnd>add</mat-icon>
          </button>
        </div>
        <div class="carousel" *ngIf="showCarousel">
          <!-- Loading state -->
          <div *ngIf="carouselLoading" class="carousel-loading">
            <mat-spinner diameter="40"></mat-spinner>
          </div>
          
          <!-- Carousel content -->
          <div *ngIf="!carouselLoading && carouselItems.length > 0" class="carousel-inner">
            <div *ngFor="let item of carouselItems; let i = index" 
                 [class.active]="i === currentCarouselIndex"
                 class="carousel-item"
                 (click)="onCarouselItemClick(item, i)">
              <!-- Inline video playback -->
              <div *ngIf="item.type === 'video' && playingCarouselIndex === i" class="carousel-video-wrap">
                <div class="carousel-video-ratio">
                  <iframe *ngIf="isYouTubeVideo(item.image)"
                          [src]="youTubeEmbedUrl(item.image)"
                          title="Demo video player"
                          frameborder="0"
                          allow="autoplay; encrypted-media; picture-in-picture"
                          allowfullscreen
                          (click)="$event.stopPropagation()">
                  </iframe>
                  <video *ngIf="!isYouTubeVideo(item.image)"
                         [src]="item.image"
                         [poster]="item.thumbnail || ''"
                         controls
                         autoplay
                         playsinline
                         (click)="$event.stopPropagation()"
                         (ended)="onCarouselVideoEnded()">
                  </video>
                </div>
                <button type="button" class="carousel-expand-btn"
                        (click)="expandCarouselVideo(item, $event)"
                        aria-label="Expand video">
                  <mat-icon>open_in_full</mat-icon>
                </button>
              </div>
              <!-- Image or video thumbnail -->
              <ng-container *ngIf="!(item.type === 'video' && playingCarouselIndex === i)">
                <img [src]="item.type === 'video' ? (item.thumbnail || item.image) : item.image" 
                     class="carousel-image"
                     [alt]="'Demo screenshot ' + (i + 1)"
                     (error)="onImageError($event, item.image)">
                <button *ngIf="item.type === 'video'" type="button"
                        class="carousel-play-overlay"
                        (click)="playCarouselVideo(i, $event)"
                        aria-label="Play video">
                  <mat-icon>play_arrow</mat-icon>
                </button>
              </ng-container>

            </div>
          </div>
          
          <!-- Controls - only show when loaded and has items -->
          <button *ngIf="!carouselLoading && carouselItems.length > 1" 
                  class="carousel-control prev" 
                  (click)="previousCarouselImage()" 
              aria-label="Previous image">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <button *ngIf="!carouselLoading && carouselItems.length > 1" 
                  class="carousel-control next" 
                  (click)="nextCarouselImage()" 
              aria-label="Next image">
            <mat-icon>chevron_right</mat-icon>
          </button>
          
          <!-- Indicators - only show when loaded and has items -->
          <div *ngIf="!carouselLoading && carouselItems.length > 1" class="carousel-indicators">
            <button *ngFor="let item of carouselItems; let i = index"
                    [class.active]="i === currentCarouselIndex"
                    (click)="goToCarouselImage(i)"
                    [attr.aria-label]="'Go to image ' + (i + 1)">
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Expanded video pop-up overlay -->
    <div *ngIf="expandedVideo" class="video-popup-backdrop" (click)="closeExpandedVideo()">
      <div class="video-popup" (click)="$event.stopPropagation()">
        <button type="button" class="video-popup-close" (click)="closeExpandedVideo()" aria-label="Close video">
          <mat-icon>close</mat-icon>
        </button>
        <iframe *ngIf="isYouTubeVideo(expandedVideo.image)"
                [src]="youTubeEmbedUrl(expandedVideo.image)"
                title="Expanded demo video player"
                class="video-popup-player"
                frameborder="0"
                allow="autoplay; encrypted-media; picture-in-picture"
                allowfullscreen>
        </iframe>
        <video *ngIf="!isYouTubeVideo(expandedVideo.image)"
               [src]="expandedVideo.image"
               [poster]="expandedVideo.thumbnail || ''"
               class="video-popup-player"
               controls
               autoplay
               playsinline>
        </video>
      </div>
    </div>

    <div class="credits-info-container" *ngIf="(this.consumption|async) as consumption">
      <div class="credits-info">
        <span>{{consumption.currentConsumption}} of {{consumption.maxCredits}}
          ({{consumption.percentage | number : '1.0-2'}}%) credits used</span>
        <mat-progress-bar [ngClass]="{'error': consumption.percentage >= 100}"
          [color]="consumption.percentage < 80 ? 'accent' : 'warn'" 
          mode="determinate"
          [value]="consumption.percentage"></mat-progress-bar>
        <span>Your credits reset on {{consumption.resetDate | date:'yyyy-MM-dd'}}</span>
      </div>
    </div>
  </div>

  <!-- Single Explore Demos Column -->

      <!-- Has Environments State -->
      <!-- <ng-container *ngIf="!((this.environments | async)?.length === 0)">
        <mat-accordion class="environment-accordion">
          <mat-expansion-panel *ngFor="let environment of (this.environments | async)"
            [class.selected]="this.selectedEnvironment!.name == environment.name"
            (opened)="this.selectedEnvironment = environment"
            hideToggle>
            <mat-expansion-panel-header hide>
              <div class="environment-header-content">
                <div class="environment-header-left">
                  <div class="environment-name">{{environment.name}}</div>
                  <div class="environment-state-badge">
                    <img *ngIf="environment.state === 'STOPPED'" class="state-icon" src="./assets/state-stopped.svg" />
                    <img *ngIf="environment.state === 'RUNNING'" class="state-icon" src="./assets/state-running.svg" />
                    <img *ngIf="['TERMINATED', 'FAILED'].includes(environment.state)" class="state-icon" src="./assets/state-terminated.svg" />
                    <mat-progress-spinner
                      *ngIf="['PROVISIONING', 'INITIALIZING', 'STARTING', 'STOPPING', 'REPAIRING', 'TERMINATING'].includes(environment.state)"
                      class="state-spinner" color="accent" mode="indeterminate" diameter="14">
                    </mat-progress-spinner>
                    <span [ngClass]="['state-text', environment.state.toLowerCase()]">{{environment.state}}</span>
                  </div>
                  <div class="environment-days">{{environment.createDate | daysRemaining }} days remaining</div>
                </div>
                <div class="environment-header-right">
                  <div class="environment-actions">
                    <img class="action-icon" matTooltip="Start environment"
                      [class.disabled]="environment.state !== 'STOPPED'"
                      (click)="$event.stopPropagation(); environment.state === 'STOPPED' && startEnvironment(environment.name)"
                      src="./assets/icon-start.svg" />
                    <img class="action-icon" matTooltip="Stop environment"
                      [class.disabled]="environment.state !== 'RUNNING'"
                      (click)="$event.stopPropagation(); environment.state === 'RUNNING' && stopEnvironment(environment.name)"
                      src="./assets/icon-stop.svg" />
                    <img class="action-icon" matTooltip="Delete environment"
                      [class.disabled]="environment.state !== 'RUNNING' && environment.state !== 'STOPPED' && environment.state !== 'TERMINATED' && environment.state !== 'FAILED'"
                      (click)="$event.stopPropagation(); (environment.state === 'RUNNING' || environment.state === 'STOPPED' || environment.state === 'TERMINATED' || environment.state === 'FAILED') && confirmDeleteEnvironment(environment.name)"
                      src="./assets/icon-delete.svg" />
                    <mat-icon class="action-icon info-icon">info</mat-icon>
                  </div>
                  <button [disabled]="environment.state !== 'RUNNING' || !getJupyterlabUrl(environment)" mat-flat-button color="primary"
                    (click)="$event.stopPropagation(); goToDemos(environment)" class="run-demos-button">
                    <span>Run Demos</span>
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                  <button *ngIf="environment.mcpDnsName" [disabled]="environment.state !== 'RUNNING' || !getMcpConfigUrl(environment)" mat-flat-button color="primary"
                    (click)="$event.stopPropagation(); goToMcpConfig(environment)" class="mcp-config-button">
                    <span *ngIf="getTeraUiCountdown(environment)" class="btn-spinner"></span>
                    <span>Try Tera</span>
                    <span *ngIf="getTeraUiCountdown(environment)" class="timer-badge">{{ getTeraUiCountdown(environment) }}</span>
                    <mat-icon *ngIf="!getTeraUiCountdown(environment)">open_in_new</mat-icon>
                  </button>
                </div>
              </div>
            </mat-expansion-panel-header>
            
            <div class="expansion-content">
              <div class="connection-info-row">
                <span class="info-label">Host:</span>
                <span class="info-value">{{ environment.dnsName }}</span>
                <fa-icon [icon]="faCopy" class="copy-icon" (click)="copyText(environment.dnsName, 'dns')"></fa-icon>
              </div>
              <div class="connection-info-row" *ngIf="environment.mcpDnsName">
                <span class="info-label">MCP:</span>
                <span class="info-value">{{ environment.mcpDnsName }}/mcp</span>
                <fa-icon [icon]="faCopy" class="copy-icon" (click)="copyText(environment.mcpDnsName + '/mcp', 'mcp')"></fa-icon>
              </div>
              <div class="connection-info-row">
                <span class="info-label">Username:</span>
                <span class="info-value">demo_user</span>
                <fa-icon [icon]="faCopy" class="copy-icon" (click)="copyText('demo_user', 'user')"></fa-icon>
              </div>
              <div class="connection-info-row">
                <span class="info-label">Password:</span>
                <span class="info-value password-hint">Password used at creation</span>
              </div>
              
              <div class="connection-details-cta">
                Need help connecting? 
                <a class="cta-link" href="https://quickstarts.teradata.com/" target="_blank">
                  View Getting Started Guide
                  <fa-icon [icon]="faExternalLink"></fa-icon>
                </a>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <div class="enviornment-list-spacer"></div>
        <div class="credits-info-container" *ngIf="(this.consumption|async)?.currentConsumption">
          <div class="credits-info">
            <span>{{(this.consumption|async)?.currentConsumption}} of {{(this.consumption|async)?.maxCredits}}
              ({{(this.consumption|async)?.percentage| number : '1.0-2'}}%) credits used</span>
            <mat-progress-bar [ngClass]="{'error':((this.consumption|async)!.percentage)>=100}"
              color="{{(((this.consumption|async)!.percentage) < 80)?'accent':'warn'}}" mode="determinate"
              value="{{(this.consumption|async)?.percentage}}"></mat-progress-bar>
            <span>Your credits reset on {{(this.consumption|async)?.resetDate | date:'YYYY-MM-dd'}}</span>
          </div>
        </div>
      </ng-container> -->

  <!-- Single Explore Demos Column -->
  <div class="demos-column column">
    <div class="notebook-viewer notebook-viewer-top" *ngIf="isNotebookViewerOpen">
      <div class="notebook-viewer-header">
        <div class="notebook-viewer-title">{{ notebookViewerTitle }}</div>
        <button mat-button class="notebook-viewer-close" (click)="closeNotebookViewer()">
          <mat-icon>arrow_back</mat-icon>
          <span>Back to Gallery</span>
        </button>
      </div>
      <iframe
        class="notebook-viewer-frame"
        [src]="notebookViewerUrl"
        title="Notebook Viewer"
        scrolling="yes"
        loading="lazy">
      </iframe>
    </div>

    <div class="demos-header" *ngIf="!isNotebookViewerOpen">
      <div class="demos-title-section">
        <h2>Use Case Notebook Gallery</h2>
        <span class="demos-subtitle">Browse read‑only notebooks to explore proven use cases</span>
      </div>
      <span class="toolbar-spacer"></span>
      <mat-icon class="info-icon" 
                matTooltip="Explore our Jupyter Notebooks by clicking on any Use Cases below to view the notebook in a Jupyter Notebook viewer. We currently have {{ allDemos.length }} notebooks that can be opened without creating an environment. Use these filtering options to limit your search, or ask our AI Assistant to help."
                matTooltipPosition="below">
        info
      </mat-icon>
    </div>
    
    <!-- Chat Toggle Button - positioned to overlap between panels -->
    <button mat-icon-button
            [matTooltip]="isChatCollapsed ? 'Open AI Assistant' : 'Close AI Assistant'" 
            (click)="toggleChat()"
            class="chat-toggle-btn">
      <mat-icon>{{ isChatCollapsed ? 'chevron_left' : 'chevron_right' }}</mat-icon>
    </button>
    
    <div class="demos-filters" *ngIf="!isNotebookViewerOpen">
      <div class="filter-group" *ngFor="let filter of subjectFilterConfigs">
        <select
          class="filter-select"
          [ngModel]="filters[filter.key]"
          (ngModelChange)="onSubjectFilterChange(filter.key, $event)"
          [disabled]="filtersLoading">
          <option value="">{{ filter.label }}</option>
          <option *ngFor="let option of filter.options" [value]="option">{{ option }}</option>
        </select>
      </div>
      <div class="filter-group">
        <select class="filter-select" [(ngModel)]="filters['availability']" (change)="onFilterChange()" [disabled]="filtersLoading">
          <option value="">Availability</option>
          <option *ngFor="let avail of filterOptions.availabilities" [value]="avail.value">{{ avail.label }}</option>
        </select>
      </div>
      
      <!-- AI Filter Chip -->
      <div class="filter-group ai-filter-chip-wrapper" *ngIf="aiFilterActive">
        <div class="ai-filter-chip">
          <mat-icon class="chip-icon">auto_awesome</mat-icon>
          <span class="chip-text">AI Filter Applied</span>
          <button mat-icon-button class="chip-close" (click)="clearAiFilter(); $event.stopPropagation()" matTooltip="Clear AI filter">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <!-- Reset All Filters Button -->
      <div class="filter-group reset-filters-wrapper" *ngIf="hasActiveFilters()">
        <button class="reset-filters-btn" (click)="clearAllFilters()" matTooltip="Clear all filters">
          <mat-icon>filter_list_off</mat-icon>
          <span>Reset Filters</span>
        </button>
      </div>
    </div>
    
    <div class="demos-list" *ngIf="!isNotebookViewerOpen">
      <div *ngIf="demosLoading" class="demos-loading">
        <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
        <p>Loading demos...</p>
      </div>
      <div *ngIf="!demosLoading && filteredDemos.length === 0" class="no-demos">
        <p>No demos found matching your filters.</p>
      </div>
      <div *ngFor="let demo of filteredDemos" class="demo-item clickable"
           (click)="launchDemo(demo)">
        <h3>
          {{ demo.demo }}
          <span *ngIf="hasNbviewerLink(demo)">&nbsp;<fa-icon [icon]="faExternalLink"></fa-icon></span>
        </h3>
        <p>{{ demo.description }}</p>
        <div class="demo-subjects" *ngIf="demo.subjects && demo.subjects.length > 0">
          <!-- Preview Available badge for notebooks with nbviewer -->
          <span *ngIf="hasNbviewerLink(demo)" 
                class="demo-subject-tag preview-available-tag" 
                matTooltip="View this notebook in your browser"
                matTooltipPosition="above">
            Preview Available
          </span>
          <!-- Environment Required badge for notebooks without nbviewer -->
          <span *ngIf="!hasNbviewerLink(demo)" 
                class="demo-subject-tag environment-required-tag" 
                matTooltip="Create an environment to explore this notebook"
                matTooltipPosition="above">
            Environment Required
          </span>
          <span *ngFor="let subject of demo.subjects.slice(0, 3)" class="demo-subject-tag">
            {{ subject.subject }}
          </span>
        </div>
        <div *ngIf="getDemoVersions(demo).length > 1" class="demo-version-badge">
          <mat-icon>layers</mat-icon>
          <span>{{ getDemoVersions(demo).length }} versions</span>
        </div>
      </div>
    </div>

  </div>

  <!-- AI Chat Panel -->
  <div class="ai-chat-panel" [class.collapsed]="isChatCollapsed" [class.expanded]="!isChatCollapsed">
    <div class="ai-chat-header toolbar">
      <div class="header">
        <mat-icon class="chat-icon">chat</mat-icon>
        <span class="logo">AI Assistant</span>
        <span class="logo-subtitle">Ask questions about our use cases and notebooks</span>
      </div>
      <span class="toolbar-spacer"></span>
      <button mat-icon-button matTooltip="Clear conversation" (click)="clearChatHistory()" [disabled]="chatMessages.length === 0">
        <mat-icon>delete_outline</mat-icon>
      </button>
    </div>
    
    <div class="ai-chat-container" [class.loading]="isChatHistoryLoading">
      <div class="chat-messages" #chatMessagesContainer>
        <div class="welcome-message" *ngIf="chatMessages.length === 0">
          <mat-icon class="welcome-icon">smart_toy</mat-icon>
          <h3>Hello! I'm your Trial AI Assistant</h3>
          <p>What can I help you with today?</p>
          <ul>
            <!-- <li>Search for demos on any topic</li>
            <li>SQL query assistance</li>
            <li>Analytics questions</li>
            <li>Demo recommendations</li> -->
          </ul>
        </div>
        
        <!-- Loading indicator for chat history -->
        <div class="chat-history-loader" *ngIf="isChatHistoryLoading">
          <div class="typing-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <p>Getting my helper ready...</p>
        </div>
        
        <div *ngFor="let msg of chatMessages; let i = index" 
             [ngClass]="msg.role === 'user' ? 'message user-message' : 'message assistant-message'">
          <div class="message-bubble" [innerHTML]="formatMessage(msg.content, msg.sourceDocuments, i)" 
               [attr.data-message-index]="i"
               (click)="onMessageClick($event, i)"></div>
        </div>
        
        <!-- Loading indicator -->
        <div class="message assistant-message" *ngIf="isChatLoading">
          <div class="message-bubble typing-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        
        <!-- Error message -->
        <div class="chat-error" *ngIf="chatError">
          <mat-icon>error_outline</mat-icon>
          <span>{{ chatError }}</span>
        </div>
      </div>
      
      <div class="chat-input-container">
        <mat-form-field class="chat-input-field" appearance="outline">
          <input matInput 
                 placeholder="Ask me anything..." 
                 [(ngModel)]="chatMessage" 
                 (keydown.enter)="sendChatMessage()"
                 [disabled]="isChatLoading">
          <button mat-icon-button 
                  matSuffix 
                  (click)="sendChatMessage()" 
                  [disabled]="!chatMessage.trim() || isChatLoading">
            <mat-icon>send</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
<div class="user-level-notifications">
  <div class="notifications" *ngFor="let notification of notifications | async">
    <div [ngClass]="['notification', 'notification-type-' + notification.type.toLowerCase()]"
      *ngIf="!notification.environment">
      <div class="notification-icon">
        <mat-icon>{{notification.type.toLowerCase()}}</mat-icon>
      </div>
      <div class="notification-body">
        <div class="middle-content">
          <div [ngClass]="['notification-title', 'notification-title-type-' + notification.type]">{{notification.title}}
          </div>
          <div [ngClass]="['notification-text', 'notification-text-type-' + notification.type]">{{notification.text}}
          </div>
        </div>
      </div>
      <span class="toolbar-spacer"></span>
      <div class="notification-delete">
        <img src="./assets/icon-close.svg" (click)="deleteNotification(notification)" />
      </div>
    </div>
  </div>
